// Copyright (c) 2016 Deere & Company

import ClaimAction, {getDefaultState as getClaimActionDefaultState} from './claim-action';
import ClaimCustomerDetails, {getDefaultState as getClaimCustomerDetailsDefaultState} from './claim-customer-details';
import ClaimMarketingReferenceInfo, {getDefaultState as getClaimMarketingReferenceInfoDefaultState} from './claim-marketing-reference-info';
import ClaimRecordInfo, {getDefaultState as getClaimClaimRecordInfoDefaultState} from './claim-record-info';
import ClaimReimbursementDetails, {getDefaultState as getClaimReimbursementDetailsDefaultState} from './claim-reimbursement-details';
import ClaimRgaStatus, {getDefaultState as getClaimRgaStatusDefaultState} from './claim-rga-status';
import ClaimRules, {getDefaultState as getClaimRulesDefaultState} from './claim-rules';
import ClaimValueDetails, {getDefaultState as getClaimValueDetailsDefaultState} from './claim-value-details';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import ClaimQuestion from './claim-question';
import ClaimVsrMessage from './claim-vsr-message';
import File from './file';
import t from 'tcomb';

const ClaimMassChannelCustomerFollowup = t.struct({
    allowedActions: t.list(ClaimAction, 'AllowedActions'),
    claimNumber: t.String,
    claimStatus: KeyValuePair,
    claimType: KeyValuePair,
    claimValueDetails: ClaimValueDetails,
    contactDate: t.maybe(t.Number),
    customerDetails: ClaimCustomerDetails,
    deliveryDate: t.maybe(t.Number),
    errors: t.list(ClaimVsrMessage, 'Errors'),
    file: t.maybe(t.list(File, 'Files')),
    goodsInstallationVat: t.maybe(KeyValuePair),
    hideClaimValueDetails: t.Bool,
    isDuplicateClaim: t.maybe(t.Bool),
    isEditable: t.Bool,
    methodOfContact: KeyValuePair,
    model: t.String,
    pin: t.String,
    questions: t.maybe(t.list(ClaimQuestion, 'Question')),
    recordInfo: ClaimRecordInfo,
    referenceInfo: ClaimMarketingReferenceInfo,
    reimbursementDetails: ClaimReimbursementDetails,
    relationship: KeyValuePair,
    responsibleAccount: Dealer,
    rgaStatus: ClaimRgaStatus,
    rules: ClaimRules,
    selectedAction: ClaimAction,
    sellingDealer: KeyValuePair,
    showAmountsInLocalCurrency: t.Bool,
    showGoodsInstallationVat: t.Bool,
    storeNumber: t.String,
    subClaimType: KeyValuePair,
    validationFailed: t.Bool,
    version: t.String
}, {
    name: 'ClaimMassChannelCustomerFollowup',
    strict: true
});

export const getDefaultState = () => new ClaimMassChannelCustomerFollowup({
    allowedActions: [
        new ClaimAction({
            actionName: 'SAVE_VALD',
            id: 'SAVE_VALD',
            mode: 'CHG'
        })
    ],
    claimNumber: '',
    claimStatus: getKeyValuePairDefaultState(),
    claimType: new KeyValuePair({
        key: 'ZZMK',
        value: ''
    }),
    claimValueDetails: getClaimValueDetailsDefaultState(),
    contactDate: null,
    customerDetails: getClaimCustomerDetailsDefaultState(),
    deliveryDate: null,
    errors: [],
    file: [],
    goodsInstallationVat: getKeyValuePairDefaultState(),
    hideClaimValueDetails: false,
    isDuplicateClaim: false,
    isEditable: true,
    methodOfContact: getKeyValuePairDefaultState(),
    model: '',
    pin: '',
    questions: [],
    recordInfo: getClaimClaimRecordInfoDefaultState(),
    referenceInfo: new ClaimMarketingReferenceInfo({
        ...getClaimMarketingReferenceInfoDefaultState(),
        referenceNumber2: ''
    }),
    reimbursementDetails: getClaimReimbursementDetailsDefaultState(),
    relationship: getKeyValuePairDefaultState(),
    responsibleAccount: getDealerDefaultState(),
    rgaStatus: getClaimRgaStatusDefaultState(),
    rules: getClaimRulesDefaultState(),
    selectedAction: getClaimActionDefaultState(),
    sellingDealer: getKeyValuePairDefaultState(),
    showAmountsInLocalCurrency: false,
    showGoodsInstallationVat: false,
    storeNumber: '',
    subClaimType: new KeyValuePair({
        key: 'MCC',
        value: ''
    }),
    validationFailed: false,
    version: ''
});

ClaimMassChannelCustomerFollowup.prototype.vsrErrorMessages = function vsrErrorMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'E');

    return errorMessages;

};

ClaimMassChannelCustomerFollowup.prototype.vsrWarningMessages = function vsrWarningMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'W');

    return errorMessages;

};

ClaimMassChannelCustomerFollowup.prototype.vsrInfoMessages = function vsrInfoMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'I');

    return errorMessages;

};

export default ClaimMassChannelCustomerFollowup;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-mass-channel-customer-followup.js